<form [formGroup]="OuCollectionForm" class="ml-8 mt-8 space-y-3 h-full">
  <div class="flex flex-row space-x-40">
    <div class="flex flex-col" style="width: 700px">
      <span class="form-field-header">OU collection name*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [required]="true"
        [hideRequiredMarker]="true"
        formControlName="name"
        placeholder="Enter a name"
      ></lib-common-ui-components-text-input>
      <span class="form-field-header">OU collection description*</span>
      <lib-common-ui-components-text-input
        floatLabel="always"
        [required]="true"
        [hideRequiredMarker]="true"
        formControlName="description"
        [textArea]="true"
        placeholder="Enter a description"
      ></lib-common-ui-components-text-input>
    </div>
  </div>
  <div style="width: 700px">
    <span class="form-field-header">Select device OU(s)*</span>
    <lib-cdw-filtered-tree-picker
      floatLabel="always"
      filterPlaceholder="Search OUs"
      [multiSelect]="true"
      formControlName="ous"
      height="500px"
      [dataSource]="ouSelectOptions"
    ></lib-cdw-filtered-tree-picker>
  </div>
  <div class="flex flex-col pt-4 pb-8" style="width: 700px">
    <div class="flex flex-row w-full space-x-4 align-center">
      <lib-cdw-button class="mr-auto" *ngIf="ouCollection" (buttonClick)="onDeleteOuCollection()" level="warn">Delete OU Collection</lib-cdw-button>
      <lib-cdw-button
        class="ml-auto"
        (buttonClick)="onCancelOuCollection()"
        level="secondary"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
        >Cancel</lib-cdw-button
      >
      <lib-cdw-button
        (buttonClick)="onSaveOuCollection()"
        level="primary"
        [disabled]="!OuCollectionForm.valid"
        fontFamily="Roboto, sans-serif"
        [fontColor]="grey400Color"
        fontWeight="700"
        >Save OU Collection</lib-cdw-button
      >
    </div>
  </div>
</form>
